/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import * as $ from 'jquery'
import {token} from "./auth/token";
import {APIHost} from "../config";
import {logout} from "./auth/authentication";
import {handlePopups} from "./popup";

interface requestProps {
    action: string,
    method: string,
    data?: any,
    dataType?: string,
    contentType?: string,
}

function request(props: requestProps): JQueryPromise<any> {
    return $.ajax({
        ...props,
        url: new URL(props.action, APIHost).toString(),
        headers: {
            'X-JWTToken': token.get(),
        },
    }).always(  // update token
        (data, status, jqXHR) => {
            let jwt;
            if (typeof jqXHR === "string") {
                jwt = data.getResponseHeader('X-JWTToken')
            } else {
                jwt = jqXHR.getResponseHeader('X-JWTToken')
            }
            if (jwt) {
                token.set(jwt);
            }
        }
    ).fail(  // handle error codes
        (jqXHR) => {
            switch (jqXHR.status) {
                case 404:
                    console.error(jqXHR);
                    break
                case 498:
                    console.debug(props.action)
                    if (props.action !== "auth/logout") {
                        console.debug("logout")
                        logout();
                    }
                    break
                default:
                    console.error("Request Failed:", jqXHR.status, jqXHR.responseJSON);
            }
        }
    ).always(
        checkForNotifications
    )
}

function checkForNotifications(data: any, status: any, jqXHR: any) {
    let notifications;
    if (typeof jqXHR === "string") {
        notifications = data.responseJSON?.notifications
    } else {
        notifications = jqXHR.responseJSON?.notifications
    }
    notifications?.forEach(
        handlePopups
    )
}

function get(uri: string): JQueryPromise<any> {
    return request({
        action: uri,
        method: "GET"
    });
}

function post(uri: string, data: { [key: string]: any }): JQueryPromise<any> {
    return request({
        action: uri,
        method: "POST",
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
    });
}

function patch(uri: string, data: { [key: string]: any }): JQueryPromise<any> {
    return request({
        action: uri,
        method: "PATCH",
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json",
    });
}

function del(uri: string): JQueryPromise<any> {
    return request({
        action: uri,
        method: "DELETE",
    });
}

const upload = (options: any) => {
    uploadDrop(options);
    uploadSend(options);
}

const uploadDrop = (options: any) => {
    console.log("uploadDrop", options, options.filename)
    let file = options.file;
    options.data.set(options.filename, file);
}

const uploadSend = (options: any) => {
    request({
        action: options.action,
        data: options.data,
        method: "POST",
        processData: false,
        // @ts-ignore
        contentType: false,
    })
        .done(options.onSuccess)
        .fail(options.onError)
}

const download = (uri: string) => {
    const downloadAnchor = window.document.getElementById('downloadAnchor') as HTMLAnchorElement;
    downloadAnchor.href = new URL(uri, APIHost).toString();
    downloadAnchor.click();
    // todo handle safari issues with different origin
}

export {get, post, patch, del, upload, uploadDrop, uploadSend, download, checkForNotifications}